var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#E8F8F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4414_41535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 32.4922C15.9246 32.4922 11 27.5676 11 21.4922C11 15.4167 15.9246 10.4922 22 10.4922C28.0754 10.4922 33 15.4167 33 21.4922C33 24.4096 31.8411 27.2075 29.7782 29.2704C27.7153 31.3333 24.9174 32.4922 22 32.4922ZM22 11.8672C16.6842 11.8672 12.375 16.1764 12.375 21.4922C12.375 26.8079 16.6842 31.1172 22 31.1172C27.3158 31.1172 31.625 26.8079 31.625 21.4922C31.625 18.9395 30.6109 16.4913 28.8059 14.6863C27.0009 12.8812 24.5527 11.8672 22 11.8672Z",
    fill: "#12B76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8125 20.8047H22.6875V16.6797H21.3125V20.8047H17.1875V22.1797H21.3125V26.3047H22.6875V22.1797H26.8125V20.8047Z",
    fill: "#12B76A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4414_41535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 10.4922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/Create-icon.a304abcbc3883816e54bbd2a9ad67593.svg";
export { ForwardRef as ReactComponent };